import React, { useState, useEffect } from "react";
import "./SearchPanel.css";

const propertyOptions = {
  rectangle: [
    { value: "layerid", label: "Layer Id" },
    { value: "layername", label: "Layer Name" },
    { value: "width", label: "Width" },
    { value: "height", label: "Height" },
  ],
  label: [
    { value: "layerid", label: "Layer Id" },
    { value: "layername", label: "Layer Name" },
    { value: "labelname", label: "Label Name" },
  ],
  polygon: [
    { value: "layerid", label: "Layer Id" },
    { value: "layername", label: "Layer Name" },
    { value: "sides", label: "Number of Sides" },
  ],
  instance: [{ value: "instanceName", label: "Instance Name" }],
};

const SearchPanel = () => {
  const [shapeType, setShapeType] = useState("rectangle");
  const [property, setProperty] = useState("layerid");
  const [value, setValue] = useState("");

  const handleSearch = () => {
    window.dispatchEvent(
      new CustomEvent("search-objects", {
        detail: { shapeType, property, value },
      })
    );
  };

  useEffect(() => {
    // ✅ compute inside the effect — no dependency warning now
    const props = propertyOptions[shapeType] || [];
    setProperty(props[0]?.value || "");
  }, [shapeType]);

  const currentProperties = propertyOptions[shapeType] || [];

  return (
    <div className="panel-container">
      <div className="panel-header">Search Panel</div>

      <div className="panel-section">
        <label>Shape Type</label>
        <select
          value={shapeType}
          onChange={(e) => setShapeType(e.target.value)}
        >
          <option value="rectangle">Rectangle</option>
          <option value="label">Label</option>
          <option value="polygon">Polygon</option>
          <option value="instance">Instance</option>
        </select>
      </div>

      <div className="panel-section">
        <label>Search Property</label>
        <select
          value={property}
          onChange={(e) => setProperty(e.target.value)}
        >
          {currentProperties.map((opt) => (
            <option key={opt.value} value={opt.value}>
              {opt.label}
            </option>
          ))}
        </select>
      </div>

      <div className="panel-section">
        <label>Value</label>
        <input
          type="text"
          placeholder="Enter value..."
          value={value}
          onChange={(e) => setValue(e.target.value)}
        />
      </div>

      <button className="search-btn" onClick={handleSearch}>
        Search
      </button>
    </div>
  );
};

export default SearchPanel;
